export const admin = {
  en: {
    // Dashboard
    localizationDashboard: 'Localization Dashboard',
    overview: 'Overview',
    quality: 'Quality',
    analytics: 'Analytics',
    community: 'Community',
    
    // Metrics
    totalLanguages: 'Total Languages',
    totalUsers: 'Total Users',
    nonEnglishUsage: 'Non-English Usage',
    avgQualityScore: 'Avg Quality Score',
    questionsTranslated: 'Questions Translated',
    averageQualityScore: 'Average Quality Score',
    reviewedItems: 'Reviewed Items',
    
    // Actions
    manage: 'Manage',
    viewDetails: 'View Details',
    filterByLanguage: 'Filter by language:',
    allLanguages: 'All Languages',
    
    // Stats
    users: 'Users',
    sessions: 'Sessions',
    audio: 'Audio',
    
    // Placeholders
    qualityChartPlaceholder: 'Quality Chart Placeholder',
    usageChartPlaceholder: 'Usage Chart Placeholder',
    recentActivityPlaceholder: 'Recent activity will appear here',
    communityStatsPlaceholder: 'Community stats will appear here',
    pendingReviewsPlaceholder: 'Pending reviews will appear here',
    topContributorsPlaceholder: 'Top contributors will appear here',
    
    // Errors
    error: 'Error',
    failedToLoadDashboard: 'Failed to load dashboard data',
    
    // Parent Controls
    parentDashboard: 'Parent Dashboard',
    children: 'Children',
    approvals: 'Approvals',
    reports: 'Reports',
    childAccount: 'Child Account',
    childAccountCreated: 'Child account created successfully',
    failedToCreateChild: 'Failed to create child account',
    approvedByParent: 'Approved by parent',
    deniedByParent: 'Denied by parent',
    approved: 'Approved',
    denied: 'Denied',
    failedToProcessApproval: 'Failed to process approval',
    unknown: 'Unknown',
    success: 'Success',
    createChild: 'Create Child',
    manageRestrictions: 'Manage Restrictions',
    setTimeLimits: 'Set Time Limits',
    viewProgress: 'View Progress',
    pendingApprovals: 'Pending Approvals',
    noChildren: 'No child accounts found',
    addFirstChild: 'Add your first child account',
    loadingDashboard: 'Loading dashboard...',
    refreshing: 'Refreshing...',
    requestProcessed: 'Request has been',
    
    // Analytics
    learningSummary: 'Learning Summary',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisQuarter: 'This Quarter',
    studyTime: 'Study Time',
    accuracy: 'Accuracy',
    questions: 'Questions',
    currentStreak: 'Current Streak',
    avgSession: 'Avg Session',
    categories: 'Categories',
    improvements: 'Improvements',
    
    // Performance Indicators
    performanceIndicators: 'Performance Indicators',
    consistency: 'Consistency',
    engagement: 'Engagement',
    progress: 'Progress',
    excellent: 'Excellent',
    good: 'Good',
    high: 'High',
    moderate: 'Moderate',
    growing: 'Growing',
    stable: 'Stable',
    
    // Analytics Tabs
    insights: 'Insights',
    recommendations: 'Recommendations',
  },
  
  es: {
    // Dashboard
    localizationDashboard: 'Panel de Localización',
    overview: 'Resumen',
    quality: 'Calidad',
    analytics: 'Análisis',
    community: 'Comunidad',
    
    // Metrics
    totalLanguages: 'Total de Idiomas',
    totalUsers: 'Total de Usuarios',
    nonEnglishUsage: 'Uso No Inglés',
    avgQualityScore: 'Puntuación de Calidad Promedio',
    questionsTranslated: 'Preguntas Traducidas',
    averageQualityScore: 'Puntuación de Calidad Promedio',
    reviewedItems: 'Elementos Revisados',
    
    // Actions
    manage: 'Gestionar',
    viewDetails: 'Ver Detalles',
    filterByLanguage: 'Filtrar por idioma:',
    allLanguages: 'Todos los Idiomas',
    
    // Stats
    users: 'Usuarios',
    sessions: 'Sesiones',
    audio: 'Audio',
    
    // Placeholders
    qualityChartPlaceholder: 'Gráfico de Calidad',
    usageChartPlaceholder: 'Gráfico de Uso',
    recentActivityPlaceholder: 'La actividad reciente aparecerá aquí',
    communityStatsPlaceholder: 'Las estadísticas de la comunidad aparecerán aquí',
    pendingReviewsPlaceholder: 'Las revisiones pendientes aparecerán aquí',
    topContributorsPlaceholder: 'Los mejores contribuyentes aparecerán aquí',
    
    // Errors
    error: 'Error',
    failedToLoadDashboard: 'Error al cargar datos del panel',
    
    // Parent Controls
    parentDashboard: 'Panel de Padres',
    children: 'Hijos',
    approvals: 'Aprobaciones',
    reports: 'Informes',
    childAccount: 'Cuenta de Hijo',
    childAccountCreated: 'Cuenta de hijo creada exitosamente',
    failedToCreateChild: 'Error al crear cuenta de hijo',
    approvedByParent: 'Aprobado por el padre',
    deniedByParent: 'Denegado por el padre',
    approved: 'Aprobado',
    denied: 'Denegado',
    failedToProcessApproval: 'Error al procesar aprobación',
    unknown: 'Desconocido',
    success: 'Éxito',
    createChild: 'Crear Hijo',
    manageRestrictions: 'Gestionar Restricciones',
    setTimeLimits: 'Establecer Límites de Tiempo',
    viewProgress: 'Ver Progreso',
    pendingApprovals: 'Aprobaciones Pendientes',
    noChildren: 'No se encontraron cuentas de hijos',
    addFirstChild: 'Agregar su primera cuenta de hijo',
    loadingDashboard: 'Cargando panel...',
    refreshing: 'Actualizando...',
    requestProcessed: 'La solicitud ha sido',
    
    // Analytics
    learningSummary: 'Resumen de Aprendizaje',
    thisWeek: 'Esta Semana',
    thisMonth: 'Este Mes',
    thisQuarter: 'Este Trimestre',
    studyTime: 'Tiempo de Estudio',
    accuracy: 'Precisión',
    questions: 'Preguntas',
    currentStreak: 'Racha Actual',
    avgSession: 'Sesión Promedio',
    categories: 'Categorías',
    improvements: 'Mejoras',
    
    // Performance Indicators
    performanceIndicators: 'Indicadores de Rendimiento',
    consistency: 'Consistencia',
    engagement: 'Compromiso',
    progress: 'Progreso',
    excellent: 'Excelente',
    good: 'Bueno',
    high: 'Alto',
    moderate: 'Moderado',
    growing: 'Creciendo',
    stable: 'Estable',
    
    // Analytics Tabs
    insights: 'Perspectivas',
    recommendations: 'Recomendaciones',
  },
  
  fr: {
    // Dashboard
    localizationDashboard: 'Tableau de Bord de Localisation',
    overview: 'Aperçu',
    quality: 'Qualité',
    analytics: 'Analytique',
    community: 'Communauté',
    
    // Metrics
    totalLanguages: 'Total des Langues',
    totalUsers: 'Total des Utilisateurs',
    nonEnglishUsage: 'Utilisation Non-Anglaise',
    avgQualityScore: 'Score de Qualité Moyen',
    questionsTranslated: 'Questions Traduites',
    averageQualityScore: 'Score de Qualité Moyen',
    reviewedItems: 'Articles Révisés',
    
    // Actions
    manage: 'Gérer',
    viewDetails: 'Voir les Détails',
    filterByLanguage: 'Filtrer par langue:',
    allLanguages: 'Toutes les Langues',
    
    // Stats
    users: 'Utilisateurs',
    sessions: 'Sessions',
    audio: 'Audio',
    
    // Placeholders
    qualityChartPlaceholder: 'Graphique de Qualité',
    usageChartPlaceholder: 'Graphique d\'Utilisation',
    recentActivityPlaceholder: 'L\'activité récente apparaîtra ici',
    communityStatsPlaceholder: 'Les statistiques de la communauté apparaîtront ici',
    pendingReviewsPlaceholder: 'Les révisions en attente apparaîtront ici',
    topContributorsPlaceholder: 'Les meilleurs contributeurs apparaîtront ici',
    
    // Errors
    error: 'Erreur',
    failedToLoadDashboard: 'Échec du chargement des données du tableau de bord',
    
    // Parent Controls
    parentDashboard: 'Tableau de Bord Parental',
    children: 'Enfants',
    approvals: 'Approbations',
    reports: 'Rapports',
    childAccount: 'Compte Enfant',
    childAccountCreated: 'Compte enfant créé avec succès',
    failedToCreateChild: 'Échec de la création du compte enfant',
    approvedByParent: 'Approuvé par le parent',
    deniedByParent: 'Refusé par le parent',
    approved: 'Approuvé',
    denied: 'Refusé',
    failedToProcessApproval: 'Échec du traitement de l\'approbation',
    unknown: 'Inconnu',
    success: 'Succès',
    createChild: 'Créer Enfant',
    manageRestrictions: 'Gérer les Restrictions',
    setTimeLimits: 'Définir les Limites de Temps',
    viewProgress: 'Voir les Progrès',
    pendingApprovals: 'Approbations en Attente',
    noChildren: 'Aucun compte enfant trouvé',
    addFirstChild: 'Ajouter votre premier compte enfant',
    loadingDashboard: 'Chargement du tableau de bord...',
    refreshing: 'Actualisation...',
    requestProcessed: 'La demande a été',
    
    // Analytics
    learningSummary: 'Résumé d\'Apprentissage',
    thisWeek: 'Cette Semaine',
    thisMonth: 'Ce Mois',
    thisQuarter: 'Ce Trimestre',
    studyTime: 'Temps d\'Étude',
    accuracy: 'Précision',
    questions: 'Questions',
    currentStreak: 'Série Actuelle',
    avgSession: 'Session Moyenne',
    categories: 'Catégories',
    improvements: 'Améliorations',
    
    // Performance Indicators
    performanceIndicators: 'Indicateurs de Performance',
    consistency: 'Cohérence',
    engagement: 'Engagement',
    progress: 'Progrès',
    excellent: 'Excellent',
    good: 'Bon',
    high: 'Élevé',
    moderate: 'Modéré',
    growing: 'Croissant',
    stable: 'Stable',
    
    // Analytics Tabs
    insights: 'Perspectives',
    recommendations: 'Recommandations',
  },
  
  de: {
    parentDashboard: 'Eltern-Dashboard',
    children: 'Kinder',
    approvals: 'Genehmigungen',
    reports: 'Berichte',
    childAccount: 'Kinderkonto',
    childAccountCreated: 'Kinderkonto erfolgreich erstellt',
    failedToCreateChild: 'Kinderkonto konnte nicht erstellt werden',
    approvedByParent: 'Vom Elternteil genehmigt',
    deniedByParent: 'Vom Elternteil abgelehnt',
    approved: 'Genehmigt',
    denied: 'Abgelehnt',
    failedToProcessApproval: 'Genehmigung konnte nicht verarbeitet werden',
    unknown: 'Unbekannt',
    success: 'Erfolg',
    createChild: 'Kind anlegen',
    manageRestrictions: 'Einschränkungen verwalten',
    setTimeLimits: 'Zeitlimits festlegen',
    viewProgress: 'Fortschritt ansehen',
    pendingApprovals: 'Ausstehende Genehmigungen',
    noChildren: 'Keine Kinderkonten gefunden',
    addFirstChild: 'Lege dein erstes Kinderkonto an',
    loadingDashboard: 'Dashboard wird geladen…',
    refreshing: 'Wird aktualisiert…',
    requestProcessed: 'Die Anfrage wurde',
    learningSummary: 'Lernzusammenfassung',
    thisWeek: 'Diese Woche',
    thisMonth: 'Diesen Monat',
    thisQuarter: 'Dieses Quartal',
    studyTime: 'Lernzeit',
    accuracy: 'Genauigkeit',
    questions: 'Fragen',
    currentStreak: 'Aktuelle Serie',
    avgSession: 'Ø Sitzung',
    categories: 'Kategorien',
    improvements: 'Verbesserungen',
    performanceIndicators: 'Leistungsindikatoren',
    consistency: 'Beständigkeit',
    engagement: 'Engagement',
    progress: 'Fortschritt',
    excellent: 'Ausgezeichnet',
    good: 'Gut',
    high: 'Hoch',
    moderate: 'Mäßig',
    growing: 'Wachsend',
    stable: 'Stabil',
    insights: 'Einblicke',
    recommendations: 'Empfehlungen',
    // Dashboard
    localizationDashboard: 'Lokalisierungs-Dashboard',
    overview: 'Übersicht',
    quality: 'Qualität',
    analytics: 'Analytik',
    community: 'Gemeinschaft',
    
    // Metrics
    totalLanguages: 'Gesamtsprachen',
    totalUsers: 'Gesamtbenutzer',
    nonEnglishUsage: 'Nicht-Englische Nutzung',
    avgQualityScore: 'Durchschn. Qualitätsbewertung',
    questionsTranslated: 'Übersetzte Fragen',
    averageQualityScore: 'Durchschnittliche Qualitätsbewertung',
    reviewedItems: 'Überprüfte Elemente',
    
    // Actions
    manage: 'Verwalten',
    viewDetails: 'Details Anzeigen',
    filterByLanguage: 'Nach Sprache filtern:',
    allLanguages: 'Alle Sprachen',
    
    // Stats
    users: 'Benutzer',
    sessions: 'Sitzungen',
    audio: 'Audio',
    
    // Placeholders
    qualityChartPlaceholder: 'Qualitätsdiagramm',
    usageChartPlaceholder: 'Nutzungsdiagramm',
    recentActivityPlaceholder: 'Aktuelle Aktivitäten werden hier angezeigt',
    communityStatsPlaceholder: 'Community-Statistiken werden hier angezeigt',
    pendingReviewsPlaceholder: 'Ausstehende Überprüfungen werden hier angezeigt',
    topContributorsPlaceholder: 'Top-Mitwirkende werden hier angezeigt',
    
    // Errors
    error: 'Fehler',
    failedToLoadDashboard: 'Dashboard-Daten konnten nicht geladen werden',
  },
  
  pt: {
    parentDashboard: 'Painel dos pais',
    children: 'Filhos',
    approvals: 'Aprovações',
    reports: 'Relatórios',
    childAccount: 'Conta infantil',
    childAccountCreated: 'Conta infantil criada com sucesso',
    failedToCreateChild: 'Falha ao criar a conta infantil',
    approvedByParent: 'Aprovado pelo responsável',
    deniedByParent: 'Negado pelo responsável',
    approved: 'Aprovado',
    denied: 'Negado',
    failedToProcessApproval: 'Falha ao processar a aprovação',
    unknown: 'Desconhecido',
    success: 'Sucesso',
    createChild: 'Criar conta infantil',
    manageRestrictions: 'Gerenciar restrições',
    setTimeLimits: 'Definir limites de tempo',
    viewProgress: 'Ver progresso',
    pendingApprovals: 'Aprovações pendentes',
    noChildren: 'Nenhuma conta infantil encontrada',
    addFirstChild: 'Adicione sua primeira conta infantil',
    loadingDashboard: 'Carregando painel…',
    refreshing: 'Atualizando…',
    requestProcessed: 'A solicitação foi',
    learningSummary: 'Resumo do aprendizado',
    thisWeek: 'Esta semana',
    thisMonth: 'Este mês',
    thisQuarter: 'Este trimestre',
    studyTime: 'Tempo de estudo',
    accuracy: 'Precisão',
    questions: 'Perguntas',
    currentStreak: 'Sequência atual',
    avgSession: 'Sessão média',
    categories: 'Categorias',
    improvements: 'Melhorias',
    performanceIndicators: 'Indicadores de desempenho',
    consistency: 'Consistência',
    engagement: 'Engajamento',
    progress: 'Progresso',
    excellent: 'Excelente',
    good: 'Bom',
    high: 'Alto',
    moderate: 'Moderado',
    growing: 'Crescendo',
    stable: 'Estável',
    insights: 'Percepções',
    recommendations: 'Recomendações',
    // Dashboard
    localizationDashboard: 'Painel de Localização',
    overview: 'Visão Geral',
    quality: 'Qualidade',
    analytics: 'Análise',
    community: 'Comunidade',
    
    // Metrics
    totalLanguages: 'Total de Idiomas',
    totalUsers: 'Total de Usuários',
    nonEnglishUsage: 'Uso Não-Inglês',
    avgQualityScore: 'Pontuação Média de Qualidade',
    questionsTranslated: 'Perguntas Traduzidas',
    averageQualityScore: 'Pontuação Média de Qualidade',
    reviewedItems: 'Itens Revisados',
    
    // Actions
    manage: 'Gerenciar',
    viewDetails: 'Ver Detalhes',
    filterByLanguage: 'Filtrar por idioma:',
    allLanguages: 'Todos os Idiomas',
    
    // Stats
    users: 'Usuários',
    sessions: 'Sessões',
    audio: 'Áudio',
    
    // Placeholders
    qualityChartPlaceholder: 'Gráfico de Qualidade',
    usageChartPlaceholder: 'Gráfico de Uso',
    recentActivityPlaceholder: 'Atividade recente aparecerá aqui',
    communityStatsPlaceholder: 'Estatísticas da comunidade aparecerão aqui',
    pendingReviewsPlaceholder: 'Revisões pendentes aparecerão aqui',
    topContributorsPlaceholder: 'Principais contribuidores aparecerão aqui',
    
    // Errors
    error: 'Erro',
    failedToLoadDashboard: 'Falha ao carregar dados do painel',
  },
  
  ru: {
    parentDashboard: 'Панель родителя',
    children: 'Дети',
    approvals: 'Одобрения',
    reports: 'Отчёты',
    childAccount: 'Детский аккаунт',
    childAccountCreated: 'Детский аккаунт успешно создан',
    failedToCreateChild: 'Не удалось создать детский аккаунт',
    approvedByParent: 'Одобрено родителем',
    deniedByParent: 'Отклонено родителем',
    approved: 'Одобрено',
    denied: 'Отклонено',
    failedToProcessApproval: 'Не удалось обработать одобрение',
    unknown: 'Неизвестно',
    success: 'Готово',
    createChild: 'Добавить ребёнка',
    manageRestrictions: 'Управление ограничениями',
    setTimeLimits: 'Установить лимиты времени',
    viewProgress: 'Посмотреть прогресс',
    pendingApprovals: 'Ожидающие одобрения',
    noChildren: 'Детские аккаунты не найдены',
    addFirstChild: 'Добавьте первый детский аккаунт',
    loadingDashboard: 'Загрузка панели…',
    refreshing: 'Обновление…',
    requestProcessed: 'Запрос был',
    learningSummary: 'Итоги обучения',
    thisWeek: 'Эта неделя',
    thisMonth: 'Этот месяц',
    thisQuarter: 'Этот квартал',
    studyTime: 'Время обучения',
    accuracy: 'Точность',
    questions: 'Вопросы',
    currentStreak: 'Текущая серия',
    avgSession: 'Средняя сессия',
    categories: 'Категории',
    improvements: 'Улучшения',
    performanceIndicators: 'Показатели результатов',
    consistency: 'Постоянство',
    engagement: 'Вовлечённость',
    progress: 'Прогресс',
    excellent: 'Отлично',
    good: 'Хорошо',
    high: 'Высокий',
    moderate: 'Умеренный',
    growing: 'Растёт',
    stable: 'Стабильно',
    insights: 'Аналитика',
    recommendations: 'Рекомендации',
    // Dashboard
    localizationDashboard: 'Панель Локализации',
    overview: 'Обзор',
    quality: 'Качество',
    analytics: 'Аналитика',
    community: 'Сообщество',
    
    // Metrics
    totalLanguages: 'Всего Языков',
    totalUsers: 'Всего Пользователей',
    nonEnglishUsage: 'Неанглийское Использование',
    avgQualityScore: 'Средний Балл Качества',
    questionsTranslated: 'Переведено Вопросов',
    averageQualityScore: 'Средний Балл Качества',
    reviewedItems: 'Проверенные Элементы',
    
    // Actions
    manage: 'Управлять',
    viewDetails: 'Посмотреть Детали',
    filterByLanguage: 'Фильтр по языку:',
    allLanguages: 'Все Языки',
    
    // Stats
    users: 'Пользователи',
    sessions: 'Сессии',
    audio: 'Аудио',
    
    // Placeholders
    qualityChartPlaceholder: 'График Качества',
    usageChartPlaceholder: 'График Использования',
    recentActivityPlaceholder: 'Недавняя активность появится здесь',
    communityStatsPlaceholder: 'Статистика сообщества появится здесь',
    pendingReviewsPlaceholder: 'Ожидающие проверки появятся здесь',
    topContributorsPlaceholder: 'Лучшие участники появятся здесь',
    
    // Errors
    error: 'Ошибка',
    failedToLoadDashboard: 'Не удалось загрузить данные панели',
  },
  
  tl: {
    parentDashboard: 'Dashboard ng Magulang',
    children: 'Mga Anak',
    approvals: 'Mga Pag-apruba',
    reports: 'Mga Ulat',
    childAccount: 'Account ng Bata',
    childAccountCreated: 'Matagumpay na nagawa ang account ng bata',
    failedToCreateChild: 'Hindi nagawa ang account ng bata',
    approvedByParent: 'Inaprubahan ng magulang',
    deniedByParent: 'Tinanggihan ng magulang',
    approved: 'Inaprubahan',
    denied: 'Tinanggihan',
    failedToProcessApproval: 'Hindi naproseso ang pag-apruba',
    unknown: 'Hindi alam',
    success: 'Tagumpay',
    createChild: 'Gumawa ng Bata',
    manageRestrictions: 'Pamahalaan ang mga Restriksyon',
    setTimeLimits: 'Magtakda ng Limitasyon sa Oras',
    viewProgress: 'Tingnan ang Progreso',
    pendingApprovals: 'Mga Nakabinbing Pag-apruba',
    noChildren: 'Walang nahanap na account ng bata',
    addFirstChild: 'Idagdag ang iyong unang account ng bata',
    loadingDashboard: 'Nilo-load ang dashboard…',
    refreshing: 'Nire-refresh…',
    requestProcessed: 'Ang kahilingan ay',
    learningSummary: 'Buod ng Pag-aaral',
    thisWeek: 'Ngayong Linggo',
    thisMonth: 'Ngayong Buwan',
    thisQuarter: 'Ngayong Quarter',
    studyTime: 'Oras ng Pag-aaral',
    accuracy: 'Katumpakan',
    questions: 'Mga Tanong',
    currentStreak: 'Kasalukuyang Streak',
    avgSession: 'Karaniwang Session',
    categories: 'Mga Kategorya',
    improvements: 'Mga Pagbuti',
    performanceIndicators: 'Mga Indikador ng Pagganap',
    consistency: 'Pagkakapare-pareho',
    engagement: 'Pakikilahok',
    progress: 'Progreso',
    excellent: 'Napakahusay',
    good: 'Mabuti',
    high: 'Mataas',
    moderate: 'Katamtaman',
    growing: 'Lumalago',
    stable: 'Matatag',
    insights: 'Mga Pananaw',
    recommendations: 'Mga Rekomendasyon',
    // Dashboard
    localizationDashboard: 'Dashboard ng Lokalisasyon',
    overview: 'Pangkalahatang-tanaw',
    quality: 'Kalidad',
    analytics: 'Analytics',
    community: 'Komunidad',
    
    // Metrics
    totalLanguages: 'Kabuuang Wika',
    totalUsers: 'Kabuuang Users',
    nonEnglishUsage: 'Hindi Ingles na Paggamit',
    avgQualityScore: 'Avg na Marka ng Kalidad',
    questionsTranslated: 'Mga Tanong na Naisalin',
    averageQualityScore: 'Average na Marka ng Kalidad',
    reviewedItems: 'Mga Na-review na Item',
    
    // Actions
    manage: 'Pamahalaan',
    viewDetails: 'Tingnan ang Detalye',
    filterByLanguage: 'I-filter ayon sa wika:',
    allLanguages: 'Lahat ng Wika',
    
    // Stats
    users: 'Mga User',
    sessions: 'Mga Session',
    audio: 'Audio',
    
    // Placeholders
    qualityChartPlaceholder: 'Chart ng Kalidad',
    usageChartPlaceholder: 'Chart ng Paggamit',
    recentActivityPlaceholder: 'Ang kamakailang aktibidad ay lilitaw dito',
    communityStatsPlaceholder: 'Ang stats ng komunidad ay lilitaw dito',
    pendingReviewsPlaceholder: 'Ang mga nakabinbing review ay lilitaw dito',
    topContributorsPlaceholder: 'Ang mga nangungunang contributor ay lilitaw dito',
    
    // Errors
    error: 'Error',
    failedToLoadDashboard: 'Hindi nai-load ang data ng dashboard',
  },
  
  it: {
    parentDashboard: 'Dashboard genitori',
    children: 'Figli',
    approvals: 'Approvazioni',
    reports: 'Report',
    childAccount: 'Account bambino',
    childAccountCreated: 'Account bambino creato con successo',
    failedToCreateChild: 'Impossibile creare l\'account bambino',
    approvedByParent: 'Approvato dal genitore',
    deniedByParent: 'Rifiutato dal genitore',
    approved: 'Approvato',
    denied: 'Rifiutato',
    failedToProcessApproval: 'Impossibile elaborare l\'approvazione',
    unknown: 'Sconosciuto',
    success: 'Fatto',
    createChild: 'Crea bambino',
    manageRestrictions: 'Gestisci restrizioni',
    setTimeLimits: 'Imposta limiti di tempo',
    viewProgress: 'Vedi progressi',
    pendingApprovals: 'Approvazioni in sospeso',
    noChildren: 'Nessun account bambino trovato',
    addFirstChild: 'Aggiungi il tuo primo account bambino',
    loadingDashboard: 'Caricamento della dashboard…',
    refreshing: 'Aggiornamento…',
    requestProcessed: 'La richiesta è stata',
    learningSummary: 'Riepilogo dell\'apprendimento',
    thisWeek: 'Questa settimana',
    thisMonth: 'Questo mese',
    thisQuarter: 'Questo trimestre',
    studyTime: 'Tempo di studio',
    accuracy: 'Precisione',
    questions: 'Domande',
    currentStreak: 'Serie attuale',
    avgSession: 'Sessione media',
    categories: 'Categorie',
    improvements: 'Miglioramenti',
    performanceIndicators: 'Indicatori di rendimento',
    consistency: 'Costanza',
    engagement: 'Coinvolgimento',
    progress: 'Progressi',
    excellent: 'Eccellente',
    good: 'Buono',
    high: 'Alto',
    moderate: 'Moderato',
    growing: 'In crescita',
    stable: 'Stabile',
    insights: 'Approfondimenti',
    recommendations: 'Raccomandazioni',
    // Dashboard
    localizationDashboard: 'Dashboard di Localizzazione',
    overview: 'Panoramica',
    quality: 'Qualità',
    analytics: 'Analitica',
    community: 'Comunità',
    
    // Metrics
    totalLanguages: 'Totale Lingue',
    totalUsers: 'Totale Utenti',
    nonEnglishUsage: 'Utilizzo Non-Inglese',
    avgQualityScore: 'Punteggio Qualità Medio',
    questionsTranslated: 'Domande Tradotte',
    averageQualityScore: 'Punteggio Qualità Medio',
    reviewedItems: 'Elementi Revisionati',
    
    // Actions
    manage: 'Gestire',
    viewDetails: 'Vedi Dettagli',
    filterByLanguage: 'Filtra per lingua:',
    allLanguages: 'Tutte le Lingue',
    
    // Stats
    users: 'Utenti',
    sessions: 'Sessioni',
    audio: 'Audio',
    
    // Placeholders
    qualityChartPlaceholder: 'Grafico Qualità',
    usageChartPlaceholder: 'Grafico Utilizzo',
    recentActivityPlaceholder: 'L\'attività recente apparirà qui',
    communityStatsPlaceholder: 'Le statistiche della comunità appariranno qui',
    pendingReviewsPlaceholder: 'Le revisioni in sospeso appariranno qui',
    topContributorsPlaceholder: 'I migliori contributori appariranno qui',
    
    // Errors
    error: 'Errore',
    failedToLoadDashboard: 'Impossibile caricare i dati del dashboard',
  },
  
  am: {
    parentDashboard: 'የወላጅ ዳሽቦርድ',
    children: 'ልጆች',
    approvals: 'ማጽደቂያዎች',
    reports: 'ሪፖርቶች',
    childAccount: 'የልጅ መለያ',
    childAccountCreated: 'የልጅ መለያ በተሳካ ሁኔታ ተፈጥሯል',
    failedToCreateChild: 'የልጅ መለያ መፍጠር አልተቻለም',
    approvedByParent: 'በወላጅ ጸድቋል',
    deniedByParent: 'በወላጅ ተከልክሏል',
    approved: 'ጸድቋል',
    denied: 'ተከልክሏል',
    failedToProcessApproval: 'ማጽደቁን ማስኬድ አልተቻለም',
    unknown: 'ያልታወቀ',
    success: 'ተሳክቷል',
    createChild: 'ልጅ ፍጠር',
    manageRestrictions: 'ገደቦችን አስተዳድር',
    setTimeLimits: 'የጊዜ ገደቦችን አዘጋጅ',
    viewProgress: 'እድገትን ይመልከቱ',
    pendingApprovals: 'በመጠባበቅ ላይ ያሉ ማጽደቂያዎች',
    noChildren: 'ምንም የልጅ መለያ አልተገኘም',
    addFirstChild: 'የመጀመሪያ የልጅ መለያዎን ይጨምሩ',
    loadingDashboard: 'ዳሽቦርድ በመጫን ላይ…',
    refreshing: 'በማደስ ላይ…',
    requestProcessed: 'ጥያቄው',
    learningSummary: 'የትምህርት ማጠቃለያ',
    thisWeek: 'በዚህ ሳምንት',
    thisMonth: 'በዚህ ወር',
    thisQuarter: 'በዚህ ሩብ ዓመት',
    studyTime: 'የጥናት ጊዜ',
    accuracy: 'ትክክለኛነት',
    questions: 'ጥያቄዎች',
    currentStreak: 'የአሁኑ ተከታታይ',
    avgSession: 'አማካይ ክፍለ ጊዜ',
    categories: 'ምድቦች',
    improvements: 'ማሻሻያዎች',
    performanceIndicators: 'የአፈጻጸም አመልካቾች',
    consistency: 'ወጥነት',
    engagement: 'ተሳትፎ',
    progress: 'እድገት',
    excellent: 'እጅግ በጣም ጥሩ',
    good: 'ጥሩ',
    high: 'ከፍተኛ',
    moderate: 'መካከለኛ',
    growing: 'እያደገ',
    stable: 'የተረጋጋ',
    insights: 'ማስተዋሎች',
    recommendations: 'ምክሮች',
    // Dashboard
    localizationDashboard: 'የአካባቢያዊነት ዳሽቦርድ',
    overview: 'አጠቃላይ እይታ',
    quality: 'ጥራት',
    analytics: 'ትንታኔ',
    community: 'ማህበረሰብ',
    
    // Metrics
    totalLanguages: 'ጠቅላላ ቋንቋዎች',
    totalUsers: 'ጠቅላላ ተጠቃሚዎች',
    nonEnglishUsage: 'እንግሊዝኛ ያልሆነ አጠቃቀም',
    avgQualityScore: 'አማካይ የጥራት ነጥብ',
    questionsTranslated: 'የተተረጎሙ ጥያቄዎች',
    averageQualityScore: 'አማካይ የጥራት ነጥብ',
    reviewedItems: 'የተገመገሙ ንጥሎች',
    
    // Actions
    manage: 'አስተዳድር',
    viewDetails: 'ዝርዝሮችን ይመልከቱ',
    filterByLanguage: 'በቋንቋ አጣራ:',
    allLanguages: 'ሁሉም ቋንቋዎች',
    
    // Stats
    users: 'ተጠቃሚዎች',
    sessions: 'ክፍለ ጊዜዎች',
    audio: 'ድምጽ',
    
    // Placeholders
    qualityChartPlaceholder: 'የጥራት ሰንጠረዥ',
    usageChartPlaceholder: 'የአጠቃቀም ሰንጠረዥ',
    recentActivityPlaceholder: 'የቅርብ ጊዜ እንቅስቃሴ እዚህ ይታያል',
    communityStatsPlaceholder: 'የማህበረሰብ ስታቲስቲክስ እዚህ ይታያሉ',
    pendingReviewsPlaceholder: 'በመጠባበቅ ላይ ያሉ ግምገማዎች እዚህ ይታያሉ',
    topContributorsPlaceholder: 'ከፍተኛ አስተዋጽዖ አድራጊዎች እዚህ ይታያሉ',
    
    // Errors
    error: 'ስህተት',
    failedToLoadDashboard: 'የዳሽቦርድ ውሂብ መጫን አልተሳካም',
  },
  
  ko: {
    parentDashboard: '보호자 대시보드',
    children: '자녀',
    approvals: '승인',
    reports: '보고서',
    childAccount: '자녀 계정',
    childAccountCreated: '자녀 계정이 생성되었습니다',
    failedToCreateChild: '자녀 계정을 만들지 못했습니다',
    approvedByParent: '보호자가 승인함',
    deniedByParent: '보호자가 거절함',
    approved: '승인됨',
    denied: '거절됨',
    failedToProcessApproval: '승인을 처리하지 못했습니다',
    unknown: '알 수 없음',
    success: '성공',
    createChild: '자녀 추가',
    manageRestrictions: '제한 관리',
    setTimeLimits: '시간 제한 설정',
    viewProgress: '진행 상황 보기',
    pendingApprovals: '대기 중인 승인',
    noChildren: '자녀 계정이 없습니다',
    addFirstChild: '첫 번째 자녀 계정을 추가하세요',
    loadingDashboard: '대시보드를 불러오는 중…',
    refreshing: '새로고침 중…',
    requestProcessed: '요청이 다음과 같이 처리되었습니다:',
    learningSummary: '학습 요약',
    thisWeek: '이번 주',
    thisMonth: '이번 달',
    thisQuarter: '이번 분기',
    studyTime: '학습 시간',
    accuracy: '정확도',
    questions: '문제',
    currentStreak: '현재 연속 기록',
    avgSession: '평균 세션',
    categories: '카테고리',
    improvements: '향상',
    performanceIndicators: '성과 지표',
    consistency: '꾸준함',
    engagement: '참여도',
    progress: '진행도',
    excellent: '매우 좋음',
    good: '좋음',
    high: '높음',
    moderate: '보통',
    growing: '성장 중',
    stable: '안정적',
    insights: '인사이트',
    recommendations: '추천',
    // Dashboard
    localizationDashboard: '현지화 대시보드',
    overview: '개요',
    quality: '품질',
    analytics: '분석',
    community: '커뮤니티',
    
    // Metrics
    totalLanguages: '전체 언어',
    totalUsers: '전체 사용자',
    nonEnglishUsage: '비영어 사용',
    avgQualityScore: '평균 품질 점수',
    questionsTranslated: '번역된 질문',
    averageQualityScore: '평균 품질 점수',
    reviewedItems: '검토된 항목',
    
    // Actions
    manage: '관리',
    viewDetails: '세부 정보 보기',
    filterByLanguage: '언어별 필터:',
    allLanguages: '모든 언어',
    
    // Stats
    users: '사용자',
    sessions: '세션',
    audio: '오디오',
    
    // Placeholders
    qualityChartPlaceholder: '품질 차트',
    usageChartPlaceholder: '사용 차트',
    recentActivityPlaceholder: '최근 활동이 여기에 표시됩니다',
    communityStatsPlaceholder: '커뮤니티 통계가 여기에 표시됩니다',
    pendingReviewsPlaceholder: '보류 중인 검토가 여기에 표시됩니다',
    topContributorsPlaceholder: '상위 기여자가 여기에 표시됩니다',
    
    // Errors
    error: '오류',
    failedToLoadDashboard: '대시보드 데이터를 로드하지 못했습니다',
  },
};